export default "__VITE_ASSET__hCN1znSu__"